import styled from 'styled-components';
import { Select } from 'components/Inputs';
import { sizes } from 'style';
import { th } from 'style/theme';

export const ClaimantSelect = styled(Select)`
  max-width: 300px;
`;

export const ClaimTypeButtons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 16px;

  > * {
    display: flex;
    flex-direction: column;
    flex: 1;
    font-size: 14px;
  }

  @media ${sizes.tabletPortrait} {
    flex-direction: row;
    gap: 36px;
  }
`;

export const ClaimTypeButtonHeading = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  font-size: 16px;
  font-weight: 600;
  color: ${th('colors.black')};

  > img {
    width: 30px;
    height: auto;
    margin-right: 12px;
  }
`;

export const FeedbackWrapper = styled.div`
  margin-bottom: 16px;
`;
